module.exports = __webpack_public_path__ + "img/human-body.492c273a.svg";